function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useContext, useMemo, useRef } from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import ThemeContext from "../ThemeProvider/ThemeContext";
import { getStyle } from "./LoadingSpinner.style";
var LoadingSpinner = function(_param) {
    var getKey = function getKey() {
        if (keyCount < Number.MAX_SAFE_INTEGER - 1) {
            return keyCount++;
        }
        keyCount = 1;
        return keyCount;
    };
    var size = _param.size, testIdProp = _param.testID, text = _param.text, textInline = _param.textInline, id = _param.id, propDrop = _objectWithoutProperties(_param, [
        "size",
        "testID",
        "text",
        "textInline",
        "id"
    ]);
    var keyCount = 1;
    var strokeId = useRef(id ? "".concat(id, "-gradient") : "".concat(getKey(), "-gradient"));
    var testID = testIdProp || id;
    var ref = useStyle({
        textInline: textInline,
        size: size
    }), outerContainerStyle = ref.outerContainerStyle, circleStyle = ref.circleStyle, tailChaserStyle = ref.tailChaserStyle, textStyle = ref.textStyle, gradientColor1 = ref.gradientColor1, gradientColor2 = ref.gradientColor2, gradientColor3 = ref.gradientColor3;
    return _jsxs("div", _objectSpread({}, propDrop, {
        id: id
    }, injectTestId(testID), {
        role: "progressbar",
        css: outerContainerStyle,
        children: [
            _jsxs("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                css: circleStyle,
                children: [
                    _jsx("defs", {
                        children: _jsxs("linearGradient", {
                            id: strokeId.current,
                            x1: "0%",
                            y1: "100%",
                            x2: "0%",
                            y2: "0%",
                            children: [
                                _jsx("stop", {
                                    offset: "0%",
                                    stopColor: gradientColor1
                                }),
                                _jsx("stop", {
                                    offset: "50%",
                                    stopColor: gradientColor2
                                }),
                                _jsx("stop", {
                                    offset: "100%",
                                    stopColor: gradientColor3
                                })
                            ]
                        })
                    }),
                    _jsx("circle", {
                        cx: "50%",
                        cy: "50%",
                        r: '50%'
                    }),
                    _jsx("circle", {
                        stroke: "url(#".concat(strokeId.current, ")"),
                        cx: "50%",
                        cy: "50%",
                        r: '50%',
                        css: tailChaserStyle
                    })
                ]
            }),
            text && size === 'm' && _jsx("h4", {
                css: textStyle,
                children: text
            })
        ]
    }));
};
export { LoadingSpinner };
function useStyle(param) {
    var size = param.size, textInline = param.textInline;
    var theme = useContext(ThemeContext);
    var ref = useMemo(function() {
        return getStyle(theme);
    }, [
        theme
    ]), outerContainer = ref.outerContainer, circle = ref.circle, tailChaser = ref.tailChaser, text = ref.text, gradientColor1 = ref.gradientColor1, gradientColor2 = ref.gradientColor2, gradientColor3 = ref.gradientColor3;
    return {
        outerContainerStyle: _objectSpread({}, outerContainer.base, size === 'l' ? outerContainer.big : {}, textInline ? outerContainer.inline : {}),
        circleStyle: _objectSpread({}, circle.base, size === 'l' ? circle.big : {}),
        tailChaserStyle: _objectSpread({}, tailChaser.base, size === 'l' ? tailChaser.big : {}),
        textStyle: _objectSpread({}, text.base, textInline ? text.inline : {}),
        gradientColor1: gradientColor1,
        gradientColor2: gradientColor2,
        gradientColor3: gradientColor3
    };
}
export default LoadingSpinner;
